<template>

</template>
<script>
    export default {
        mounted() {
            this.$store.dispatch('auth/logout');
            this.$router.push({name: 'login'});
        }
    };
</script>